import { useApolloClient } from '@apollo/client'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'

const useLogout = () => {
  const navigate = useNavigate()
  const client = useApolloClient()

  return () => {
    Cookies.remove('authToken')
    navigate('/')
    setTimeout(client.resetStore, 100)
  }
}

export default useLogout
